import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import ExportExtentionForm from '@app/components/apps/Export/ExportExtention/ExportExtentionForm';

export const ViewExportExtension: React.FC = () => {
  const location = useLocation();
  const { id, export_id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Export-Extension');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  // console.log('ViewFollowUp received:', { id, export_id });

  const routes = [
    {
      path: '/export-extensions',
      breadcrumbName: 'Export-Extensions',
    },
    {
      path: '/view-export-extension',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <ExportExtentionForm
          type="view"
          editable={false}
          id={id}
          export_id={export_id}
          pageTitle={`View Export-Extension`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Row>
    </>
  );
};

export default ViewExportExtension;
